import { useQuery } from "@apollo/client"
import { ALL_FORMATS } from "../queries/allFormats"

export interface TournamentFormat {
  id: number
  name: string
  status: number
  totalTournaments?: number
  minDeck?: number
  maxDeck?: number
  maxCopies?: number
  FormatGames: {
    gameId: number
    formatId: number
  }[]
}

export const useAllFormats = () => {
  const { data, loading, error, refetch } = useQuery<{
    allFormats: TournamentFormat[]
  }>(ALL_FORMATS, {
    errorPolicy: "all",
  })

  return {
    formats: data?.allFormats || [],
    loading,
    error,
    refetch,
  }
}
